import api from '@/api/services/api'

const update = data => api({
  method: 'post',
  url: 'agency/sendUpdateRequest',
  data
})

export {
  update
}